import { EventEmitter, inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map, Observable, of } from 'rxjs';
import { QuoteRequest, QuoteRequestsListItem, QuoteRequestsListResponse } from './quote-request.type';
import { OpenQuoteRequestResponse } from '../../dashboard/open-quote-requests-widget/quote-requests.types';
import { CathyService } from '@sbd-doug-frontend/app/services/cathy.service';

@Injectable({ providedIn: 'root' })
export class QuoteRequestsListService {
  _httpClient = inject(HttpClient);
  _cathyService = inject(CathyService);
  totalQuoteRequests = signal<number>(0);
  quoteRequests = signal<QuoteRequest[]>([]);
  notFilterableFields = signal<string[]>([]);
  triggerRefresh = new EventEmitter<void>();
  isLoading = signal<boolean>(false);

  getQuoteRequestsList(filters: any = {}): Observable<QuoteRequestsListItem[]> {
    const params = filters || {};
    this.isLoading.set(true);
    return this._httpClient
      .get <QuoteRequestsListResponse>(
        `${environment.apiBaseUrl}/v4/quote/requests`,
        { params },
      ).pipe(
        map((response) => {
          this.quoteRequests.set(response.data.quote_requests.quote_requests);
          this.totalQuoteRequests.set(response.data.quote_requests.total_quote_requests);
          this.notFilterableFields.set(response.data.not_filterable);
          this.isLoading.set(false);
          return response.data.quote_requests.quote_requests;
        }),
      );
  }


  loadQuoteRequest(quoteRequestId: number): Observable<QuoteRequestsListItem> {
    return this._httpClient
      .get<OpenQuoteRequestResponse>(
        `${environment.apiBaseUrl}/v4/quote/load-request/${quoteRequestId}`,
      ).pipe(
        map((response) => {
          if(!response.success) {
            this._cathyService.error(response.message);
          }
          return response.data.quote_request.quote_request;
        }),
      );
  }

}


